import _extends from "@babel/runtime/helpers/esm/extends";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { memo, useEffect, useState, useRef } from "react";
import { useHistory } from 'react-router-dom';
import { Alert, Button } from "react-bootstrap";
import { AuthenticationState } from "react-aad-msal";
import Wrapper from "../wrapper/Wrapper";
import { Container, Row, Col } from "react-bootstrap";
import Modal from '../modal/Modal';
import { ChangeDelivery as ChangeDeliveryForm } from '../forms/ChangeDelivery';
import { Button as StateButton, RouterStateButton } from '../forms/elements';
import { handleModNames } from "../../util";
import { CATALOGUETYPES } from "../../constants";
import { mobileAppUtil } from "../../util/mobileAppUtil";
import { ecommViewCart } from "../../util/ga-analytics/events/viewCart";
import { Cost, itemHandler, CartOptionSelect, CartLineGroup, Section, CartRetailSelect } from "./CartHelpers";
import { SectionBanner } from "./CheckoutHelpers";
import { cartFormikEnhancer } from "./formik/cartFormikEnhancer"; //ga tracker

import gaTracker from '../../util/ga-analytics/gaTracker';
import CartContinue from './CartContinue';
import MediaQuery from 'react-responsive';
import { formatPhoneNumber } from "../../util/helper";
import { Debug } from "../forms/Debug";
import { isNull } from "lodash";
import RewardRedemptionModule from './RewardRedemptionModule/RewardRedemptionModule';

var Cart = function Cart(props) {
  var _limitModel$RewardRed, _limitModel$RewardRed2, _limitModel$RewardRed3, _limitModel$RewardRed4, _fullCart$price2, _fullCart$price3, _limitModel$RewardRed5, _fullCart$displayErro, _fullCart$displayErro2, _fullCart$displayErro3, _fullCart$displayErro4, _fullCart$displayErro5, _fullCart$displayErro6;

  var silverwareRoute = props.silverwareRoute,
      fullCart = props.fullCart,
      _props$cost = props.cost,
      cost = _props$cost === void 0 ? {} : _props$cost,
      _props$cart = props.cart,
      cart = _props$cart === void 0 ? [] : _props$cart,
      _props$destructuredCa = props.destructuredCart,
      destructuredCart = _props$destructuredCa === void 0 ? {} : _props$destructuredCa,
      _props$getCart = props.getCart,
      getCart = _props$getCart === void 0 ? function () {
    return "";
  } : _props$getCart,
      _props$saveDeliveryMo = props.saveDeliveryMode,
      saveDeliveryMode = _props$saveDeliveryMo === void 0 ? function (delivery) {
    return console.log("setTime", delivery);
  } : _props$saveDeliveryMo,
      _props$setShippingMod = props.setShippingMode,
      setShippingMode = _props$setShippingMod === void 0 ? function (shippingMode) {
    return console.log("shippingMode");
  } : _props$setShippingMod,
      _props$setTime = props.setTime,
      setTime = _props$setTime === void 0 ? function (arg1, arg2, arg3) {
    return console.log("setTime", arg1, arg2, arg3);
  } : _props$setTime,
      goToCheckout = props.goToCheckout,
      _props$resetGoToCheck = props.resetGoToCheckout,
      resetGoToCheckout = _props$resetGoToCheck === void 0 ? function () {
    return console.log("resetGoToCheckout");
  } : _props$resetGoToCheck,
      _props$saveForEdit = props.saveForEdit,
      saveForEdit = _props$saveForEdit === void 0 ? function () {
    return "";
  } : _props$saveForEdit,
      _props$getDeliveryMod = props.getDeliveryModes,
      getDeliveryModes = _props$getDeliveryMod === void 0 ? function () {
    return console.log("getDeliveryModesNotFound");
  } : _props$getDeliveryMod,
      _props$getShippingMod = props.getShippingModes,
      getShippingModes = _props$getShippingMod === void 0 ? function () {
    return console.log("getShippingModesNotFound");
  } : _props$getShippingMod,
      _props$handleLogin = props.handleLogin,
      handleLogin = _props$handleLogin === void 0 ? function () {
    return console.log("getDeliveryModesNotFound");
  } : _props$handleLogin,
      _props$setPaypalOrder = props.setPaypalOrder,
      setPaypalOrder = _props$setPaypalOrder === void 0 ? function () {
    return console.log("setPaypalOrder");
  } : _props$setPaypalOrder,
      _props$requestPaypalO = props.requestPaypalOrder,
      requestPaypalOrder = _props$requestPaypalO === void 0 ? function () {
    return console.log("requestPaypalOrder");
  } : _props$requestPaypalO,
      _props$setRetail = props.setRetail,
      setRetail = _props$setRetail === void 0 ? function () {
    return console.log("setRetail");
  } : _props$setRetail,
      deliveryMode = props.deliveryMode,
      shippingMode = props.shippingMode,
      _props$deliveryModes = props.deliveryModes,
      deliveryModes = _props$deliveryModes === void 0 ? [] : _props$deliveryModes,
      _props$shippingModes = props.shippingModes,
      shippingModes = _props$shippingModes === void 0 ? [] : _props$shippingModes,
      _props$shippingCosts = props.shippingCosts,
      shippingCosts = _props$shippingCosts === void 0 ? [] : _props$shippingCosts,
      _props$authentication = props.authenticationState,
      authenticationState = _props$authentication === void 0 ? AuthenticationState.Unauthenticated : _props$authentication,
      _props$food = props.food,
      food = _props$food === void 0 ? {} : _props$food,
      _props$cater = props.cater,
      cater = _props$cater === void 0 ? {} : _props$cater,
      isCater = props.isCater,
      isFood = props.isFood,
      isRetail = props.isRetail,
      _props$isLoading = props.isLoading,
      isLoading = _props$isLoading === void 0 ? false : _props$isLoading,
      _props$removeTipAndEn = props.removeTipAndEntitlements,
      removeTipAndEntitlements = _props$removeTipAndEn === void 0 ? function () {
    return console.log("removeTipAndEntitlements");
  } : _props$removeTipAndEn,
      _props$resetToASAP = props.resetToASAP,
      resetToASAP = _props$resetToASAP === void 0 ? function () {
    return console.log("resetToASAP");
  } : _props$resetToASAP,
      _props$values = props.values,
      values = _props$values === void 0 ? {} : _props$values,
      dumpCart = props.dumpCart,
      _props$errors = props.errors,
      errors = _props$errors === void 0 ? {} : _props$errors,
      _props$removeAllGiftC = props.removeAllGiftCards,
      removeAllGiftCards = _props$removeAllGiftC === void 0 ? function () {
    return "";
  } : _props$removeAllGiftC,
      _props$setFieldValue = props.setFieldValue,
      setFieldValue = _props$setFieldValue === void 0 ? function () {
    return "";
  } : _props$setFieldValue,
      _props$clearStates = props.clearStates,
      clearStates = _props$clearStates === void 0 ? function () {
    return "";
  } : _props$clearStates,
      _props$location = props.location,
      location = _props$location === void 0 ? {} : _props$location,
      isValidatingTimeWanted = props.isValidatingTimeWanted,
      _props$limitModel = props.limitModel,
      limitModel = _props$limitModel === void 0 ? {} : _props$limitModel,
      accountInfo = props.accountInfo,
      _props$registerLogin = props.registerLogin,
      registerLogin = _props$registerLogin === void 0 ? false : _props$registerLogin;
  var _destructuredCart$foo = destructuredCart.foodItems,
      foodItems = _destructuredCart$foo === void 0 ? [] : _destructuredCart$foo,
      _destructuredCart$cat = destructuredCart.caterItems,
      caterItems = _destructuredCart$cat === void 0 ? [] : _destructuredCart$cat,
      _destructuredCart$ret = destructuredCart.retailItems,
      retailItems = _destructuredCart$ret === void 0 ? [] : _destructuredCart$ret;

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      errorsList = _useState2[0],
      setErrors = _useState2[1];

  var _useState3 = useState([]),
      _useState4 = _slicedToArray(_useState3, 2),
      sections = _useState4[0],
      setSections = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      isPayPal = _useState6[0],
      setPayPal = _useState6[1];

  var _useState7 = useState(false),
      _useState8 = _slicedToArray(_useState7, 2),
      paypalLoaded = _useState8[0],
      setPaypalLoaded = _useState8[1];

  var _useState9 = useState(cost),
      _useState10 = _slicedToArray(_useState9, 2),
      storedCost = _useState10[0],
      setStoredCost = _useState10[1];

  var _useState11 = useState(deliveryMode),
      _useState12 = _slicedToArray(_useState11, 2),
      storedDelivery = _useState12[0],
      setSotredDelivery = _useState12[1];

  var _useState13 = useState(shippingMode),
      _useState14 = _slicedToArray(_useState13, 2),
      storedShipping = _useState14[0],
      setStoredShipping = _useState14[1];

  var ref = useRef(storedCost);

  var _useState15 = useState(false),
      _useState16 = _slicedToArray(_useState15, 2),
      removeTipAndEntitlementsState = _useState16[0],
      setRemoveTipAndEntitlementsState = _useState16[1];

  useEffect(function () {
    clearStates();
    var jwtIdToken = (accountInfo === null || accountInfo === void 0 ? void 0 : accountInfo.jwtIdToken) ? accountInfo === null || accountInfo === void 0 ? void 0 : accountInfo.jwtIdToken : null;

    if (registerLogin === true && jwtIdToken) {
      getCart(jwtIdToken);
    } else if (registerLogin === false && jwtIdToken === null) {
      getCart(null);
    }
  }, [accountInfo === null || accountInfo === void 0 ? void 0 : accountInfo.jwtIdToken, registerLogin]);
  useEffect(function () {
    constructSections({
      isCater: isCater,
      isFood: isFood,
      isRetail: isRetail
    });
    if (!isCater && values.caterTime === "scheduled") setFieldValue("caterTime", "");
    if (!isFood && values.foodTime === "scheduled") setFieldValue("foodTime", "");
  }, [isCater, isFood, isRetail]);
  useEffect(function () {
    if (location && (isCater || isFood)) getDeliveryModes();
  }, [isCater, isFood, location]);
  useEffect(function () {
    if (cost === null || cost === void 0 ? void 0 : cost.DeliveryCharge) {
      console.log(cost === null || cost === void 0 ? void 0 : cost.DeliveryCharge);
      resetToASAP();
    }

    if (cost === null || cost === void 0 ? void 0 : cost.Used) removeAllGiftCards();

    if (isRetail) {
      getShippingModes();
    }

    if (isRetail && !isCater && !isFood) {
      setPayPal(true);
    } // setStoredCost(cost);


    setSotredDelivery(deliveryMode);

    if (mobileAppUtil.isMobileApp()) {
      ref.current.cost = cost;
    } else {
      ref.cost = cost;
    }
  }, [cost, deliveryMode, isRetail]); // useEffect(() => {
  //   if(shippingMode ){
  //     refDelivery = shippingMode;
  //   }
  // }, [shippingMode])

  useEffect(function () {
    if (shippingMode) {
      if (mobileAppUtil.isMobileApp()) {
        ref.current.deliveryMode = shippingMode;
      } else {
        ref.deliveryMode = shippingMode;
      }
    }
  }, [shippingMode]);
  var layout = {
    background: "white",
    padding: "medium"
  };

  var _ref = food || {},
      _ref$LeadTimeEstimate = _ref.LeadTimeEstimateMinutes,
      foodLead = _ref$LeadTimeEstimate === void 0 ? 30 : _ref$LeadTimeEstimate;

  var _ref2 = cater || {},
      _ref2$LeadTimeEstimat = _ref2.LeadTimeEstimateMinutes,
      caterLead = _ref2$LeadTimeEstimat === void 0 ? 120 : _ref2$LeadTimeEstimat;

  var signIn = function signIn() {
    var _limitModel$Unauthent, _limitModel$Unauthent2, _limitModel$Unauthent3, _limitModel$Unauthent4, _limitModel$Unauthent5;

    if (limitModel === null || limitModel === void 0 ? void 0 : (_limitModel$Unauthent = limitModel.UnauthenticatedModule) === null || _limitModel$Unauthent === void 0 ? void 0 : (_limitModel$Unauthent2 = _limitModel$Unauthent[0]) === null || _limitModel$Unauthent2 === void 0 ? void 0 : (_limitModel$Unauthent3 = _limitModel$Unauthent2.fields) === null || _limitModel$Unauthent3 === void 0 ? void 0 : (_limitModel$Unauthent4 = _limitModel$Unauthent3.SignInButton) === null || _limitModel$Unauthent4 === void 0 ? void 0 : (_limitModel$Unauthent5 = _limitModel$Unauthent4.value) === null || _limitModel$Unauthent5 === void 0 ? void 0 : _limitModel$Unauthent5.href) {
      var _limitModel$Unauthent6, _limitModel$Unauthent7, _limitModel$Unauthent8, _limitModel$Unauthent9, _limitModel$Unauthent10;

      window.location.href = limitModel === null || limitModel === void 0 ? void 0 : (_limitModel$Unauthent6 = limitModel.UnauthenticatedModule) === null || _limitModel$Unauthent6 === void 0 ? void 0 : (_limitModel$Unauthent7 = _limitModel$Unauthent6[0]) === null || _limitModel$Unauthent7 === void 0 ? void 0 : (_limitModel$Unauthent8 = _limitModel$Unauthent7.fields) === null || _limitModel$Unauthent8 === void 0 ? void 0 : (_limitModel$Unauthent9 = _limitModel$Unauthent8.SignInButton) === null || _limitModel$Unauthent9 === void 0 ? void 0 : (_limitModel$Unauthent10 = _limitModel$Unauthent9.value) === null || _limitModel$Unauthent10 === void 0 ? void 0 : _limitModel$Unauthent10.href;
    } else {
      if (typeof handleLogin === 'function') {
        return handleLogin();
      }
    }
  };

  var validatePage = function validatePage() {
    var travel = {
      "retailDeliveryMode": isRetail ? values.retailDelivery : null,
      //values.retailDelivery || null : null,
      "foodDeliveryMode": isFood ? values.foodDelivery || null : null,
      "caterDeliveryMode": isCater ? values.cateringDelivery || null : null
    };
    console.log('Check delivery modes: ', travel); //setdelivery mode now found in checkout page

    saveDeliveryMode(travel);

    var timeWanted = _objectSpread({
      foodTimeWanted: null,
      caterTimeWanted: null
    }, travel);

    var foodType = values.foodTime;
    var caterType = values.cateringTime;

    if (isCater && caterType === "scheduled") {
      if (values.cateringDueTime && values.cateringDate) {
        timeWanted.caterTimeWanted = {
          time: values.cateringDueTime,
          date: values.cateringDate
        };
      } else {
        setTime(timeWanted);
        return console.log("CATER, error");
      }
    }

    if (isFood && foodType === "scheduled") {
      if (values.foodDueTime && values.foodDate) {
        timeWanted.foodTimeWanted = {
          time: values.foodDueTime,
          date: values.foodDate
        };
      } else {
        setTime(timeWanted);
        return console.log("FOOD, error");
      }
    }

    if ((isCater || isFood) && (caterType === "scheduled" || foodType === "scheduled")) {
      //Figure out time here
      return setTime(timeWanted);
    } else {
      if (!paypalLoaded) {
        return resetGoToCheckout(true);
      } else {
        return true;
      }
    }
  };

  var stashEdit = function stashEdit(product, link, hash) {
    console.log('Stash for edit: ', product);
    saveForEdit(product, link, hash);
  };

  var constructSections = function constructSections(_ref3) {
    var isFood = _ref3.isFood,
        isCater = _ref3.isCater,
        isRetail = _ref3.isRetail;
    var sections = ["1cart"];

    if (isFood) {
      sections.push("2food");
    }

    if (isCater) {
      sections.push("3cater");
    }

    if (isRetail) {
      sections.push("4retail");
    }

    setSections(sections);
  };

  if (goToCheckout) {
    //window.location.pathname = "/checkout"
    var history = useHistory();
    history.push('/checkout');
  }

  var amt = cart.length;
  values.isCater = isCater;

  if (!isCater) {
    delete values.cateringDate;
    delete values.cateringDelivery;
    delete values.cateringDueTime;
    delete values.cateringTime;
    delete errors.cateringDate;
  }

  var hasIPMerror = false;
  var info = cart.map(function (product) {
    return {
      DisplayName: product.Product.DisplayName,
      quantity: product.Quantity
    };
  });
  var IPMFilter = info.filter(function (name) {
    var _name$DisplayName;

    return (_name$DisplayName = name.DisplayName) === null || _name$DisplayName === void 0 ? void 0 : _name$DisplayName.includes("Individually Packaged Meal");
  });
  var IPMQuantity = IPMFilter.map(function (quantity) {
    return quantity.quantity;
  });
  var totalIPM = IPMQuantity.reduce(function (a, b) {
    return a + b;
  }, 0);

  if (totalIPM != 0) {
    if (totalIPM > 20 || totalIPM < 8) {
      errors["TotalIPM"] = "quantity not met or exceeded", hasIPMerror = true;
    } else if (totalIPM <= 20 || totalIPM >= 8) {
      delete errors.TotalIPM, hasIPMerror = false;
    }
  }

  var hasItemError = false;
  var itemMax = limitModel === null || limitModel === void 0 ? void 0 : limitModel.overrideMax;
  var itemMin = limitModel === null || limitModel === void 0 ? void 0 : limitModel.overrideMin;
  var limitMessage = limitModel === null || limitModel === void 0 ? void 0 : limitModel.errorMessage;
  var cartInfo = cart.map(function (product) {
    return {
      DisplayName: product.Product.DisplayName,
      quantity: product.Quantity
    };
  });
  var itemFilter = cartInfo.filter(function (name) {
    var _name$DisplayName2;

    return (_name$DisplayName2 = name.DisplayName) === null || _name$DisplayName2 === void 0 ? void 0 : _name$DisplayName2.includes(limitModel === null || limitModel === void 0 ? void 0 : limitModel.displayName);
  });
  var itemQuantity = itemFilter.map(function (quantity) {
    return quantity.quantity;
  });
  var limitTotal = itemQuantity.reduce(function (a, b) {
    return a + b;
  }, 0);

  if (limitTotal != 0) {
    if (limitTotal > itemMax || limitTotal < itemMin) {
      errors["limitTotal"] = "quantity not met or exceeded", hasItemError = true;
    } else if (limitTotal <= itemMax || limitTotal >= itemMin) {
      delete errors.limitTotal, hasItemError = false;
    }
  }

  var isDisabled = !(isCater || isFood || isRetail) || Object.values(errors).length != 0;

  var signInClick = function signInClick() {
    var data = {
      gtm: {
        uniqueEventId: '103',
        elementId: "signin"
      },
      event: 'gtm.click'
    };
    gaTracker(data);
  };

  var continueGuestClick = function continueGuestClick() {
    var info = JSON.stringify(cart.map(function (product) {
      return {
        id: product.Id,
        quantity: product.Quantity
      };
    }));
    var data = {
      gtm: {
        uniqueEventId: '104',
        elementId: "continue"
      },
      event: 'gtm.click'
    };
    gaTracker(data);
  };

  var cartClick = function cartClick() {
    var info = JSON.stringify(cart.map(function (product) {
      return {
        id: product.Id,
        quantity: product.Quantity
      };
    }));
    var data = {
      gtm: {
        uniqueEventId: '105',
        targetElement: info,
        elementId: "checkout"
      },
      event: 'gtm.click'
    };
    gaTracker(data);
  };

  var removeItemRewardsConfirmationFields = (limitModel === null || limitModel === void 0 ? void 0 : (_limitModel$RewardRed = limitModel.RewardRedemption) === null || _limitModel$RewardRed === void 0 ? void 0 : (_limitModel$RewardRed2 = _limitModel$RewardRed[0]) === null || _limitModel$RewardRed2 === void 0 ? void 0 : (_limitModel$RewardRed3 = _limitModel$RewardRed2.fields) === null || _limitModel$RewardRed3 === void 0 ? void 0 : (_limitModel$RewardRed4 = _limitModel$RewardRed3.RemoveItem) === null || _limitModel$RewardRed4 === void 0 ? void 0 : _limitModel$RewardRed4[0].fields) || null;
  useEffect(function () {
    _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _fullCart$price, _fullCart$savedPromos;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;

              if (!((fullCart === null || fullCart === void 0 ? void 0 : (_fullCart$price = fullCart.price) === null || _fullCart$price === void 0 ? void 0 : _fullCart$price.Subtotal) && !removeTipAndEntitlementsState)) {
                _context.next = 5;
                break;
              }

              _context.next = 4;
              return removeTipAndEntitlements([]);

            case 4:
              if (!fullCart.price.GiftCardTotal > 0 && !fullCart.price.OloTip > 0 && !(fullCart === null || fullCart === void 0 ? void 0 : (_fullCart$savedPromos = fullCart.savedPromos) === null || _fullCart$savedPromos === void 0 ? void 0 : _fullCart$savedPromos.length)) {
                setRemoveTipAndEntitlementsState(true);
              }

            case 5:
              _context.next = 10;
              break;

            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](0);
              console.log('Error removeTipAndEntitlements: ', _context.t0.message);

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 7]]);
    }))();
  }, [fullCart === null || fullCart === void 0 ? void 0 : (_fullCart$price2 = fullCart.price) === null || _fullCart$price2 === void 0 ? void 0 : _fullCart$price2.GiftCardTotal, fullCart === null || fullCart === void 0 ? void 0 : (_fullCart$price3 = fullCart.price) === null || _fullCart$price3 === void 0 ? void 0 : _fullCart$price3.OloTip, fullCart === null || fullCart === void 0 ? void 0 : fullCart.savedPromos]);

  var _useState17 = useState(false),
      _useState18 = _slicedToArray(_useState17, 2),
      ranOnce = _useState18[0],
      setRanOnce = _useState18[1];

  useEffect(function () {
    if (destructuredCart && !!(destructuredCart === null || destructuredCart === void 0 ? void 0 : destructuredCart.foodItems) && !ranOnce) {
      setRanOnce(true);
      ecommViewCart({
        items: [].concat(_toConsumableArray(foodItems.map(function (foodItem, i) {
          var _foodItem$Product, _foodItem$Price, _foodItem$Product2, _foodItem$Product3, _foodItem$Product4, _foodItem$Price2, _foodItem$Price3;

          return {
            detailLink: (foodItem === null || foodItem === void 0 ? void 0 : (_foodItem$Product = foodItem.Product) === null || _foodItem$Product === void 0 ? void 0 : _foodItem$Product.DetailLink) || '',
            // addon_selected: null,
            // affiliation: model?.fullElement?.CatalogName || '',
            // byob_item: null,
            currency: 'USD',
            discount: (foodItem === null || foodItem === void 0 ? void 0 : (_foodItem$Price = foodItem.Price) === null || _foodItem$Price === void 0 ? void 0 : _foodItem$Price.TotalSavings) || 0,
            index: i,
            sku: (foodItem === null || foodItem === void 0 ? void 0 : (_foodItem$Product2 = foodItem.Product) === null || _foodItem$Product2 === void 0 ? void 0 : _foodItem$Product2.StoreProudctId) || '',
            item_id: (foodItem === null || foodItem === void 0 ? void 0 : (_foodItem$Product3 = foodItem.Product) === null || _foodItem$Product3 === void 0 ? void 0 : _foodItem$Product3.StoreProudctId) || '',
            item_name: (foodItem === null || foodItem === void 0 ? void 0 : (_foodItem$Product4 = foodItem.Product) === null || _foodItem$Product4 === void 0 ? void 0 : _foodItem$Product4.DisplayName) || '',
            // item_list_name: itemListTitle.value,
            // item_list_id: itemListTitle.value,
            // item_variant: variantOptions,
            quantity: (foodItem === null || foodItem === void 0 ? void 0 : foodItem.Quantity) || 1,
            // reward_applied: null,
            price: foodItem === null || foodItem === void 0 ? void 0 : (_foodItem$Price2 = foodItem.Price) === null || _foodItem$Price2 === void 0 ? void 0 : _foodItem$Price2.Subtotal,
            value: (foodItem === null || foodItem === void 0 ? void 0 : (_foodItem$Price3 = foodItem.Price) === null || _foodItem$Price3 === void 0 ? void 0 : _foodItem$Price3.Subtotal) * ((foodItem === null || foodItem === void 0 ? void 0 : foodItem.Quantity) || 1)
          };
        })), _toConsumableArray(caterItems.map(function (caterItem, i) {
          var _caterItem$Product, _caterItem$Price, _caterItem$Product2, _caterItem$Product3, _caterItem$Product4, _caterItem$Price2, _caterItem$Price3;

          return {
            detailLink: (caterItem === null || caterItem === void 0 ? void 0 : (_caterItem$Product = caterItem.Product) === null || _caterItem$Product === void 0 ? void 0 : _caterItem$Product.DetailLink) || '',
            // addon_selected: null,
            // affiliation: model?.fullElement?.CatalogName || '',
            // byob_item: null,
            currency: 'USD',
            discount: (caterItem === null || caterItem === void 0 ? void 0 : (_caterItem$Price = caterItem.Price) === null || _caterItem$Price === void 0 ? void 0 : _caterItem$Price.TotalSavings) || 0,
            index: i,
            sku: (caterItem === null || caterItem === void 0 ? void 0 : (_caterItem$Product2 = caterItem.Product) === null || _caterItem$Product2 === void 0 ? void 0 : _caterItem$Product2.StoreProudctId) || '',
            item_id: (caterItem === null || caterItem === void 0 ? void 0 : (_caterItem$Product3 = caterItem.Product) === null || _caterItem$Product3 === void 0 ? void 0 : _caterItem$Product3.StoreProudctId) || '',
            item_name: (caterItem === null || caterItem === void 0 ? void 0 : (_caterItem$Product4 = caterItem.Product) === null || _caterItem$Product4 === void 0 ? void 0 : _caterItem$Product4.DisplayName) || '',
            // item_list_name: itemListTitle.value,
            // item_list_id: itemListTitle.value,
            // item_variant: variantOptions,
            quantity: (caterItem === null || caterItem === void 0 ? void 0 : caterItem.Quantity) || 1,
            // reward_applied: null,
            price: caterItem === null || caterItem === void 0 ? void 0 : (_caterItem$Price2 = caterItem.Price) === null || _caterItem$Price2 === void 0 ? void 0 : _caterItem$Price2.Subtotal,
            value: (caterItem === null || caterItem === void 0 ? void 0 : (_caterItem$Price3 = caterItem.Price) === null || _caterItem$Price3 === void 0 ? void 0 : _caterItem$Price3.Subtotal) * ((caterItem === null || caterItem === void 0 ? void 0 : caterItem.Quantity) || 1)
          };
        }))),
        value: caterItems.reduce(function (acc, caterItem) {
          var _caterItem$Price4;

          acc += (caterItem === null || caterItem === void 0 ? void 0 : (_caterItem$Price4 = caterItem.Price) === null || _caterItem$Price4 === void 0 ? void 0 : _caterItem$Price4.Subtotal) * ((caterItem === null || caterItem === void 0 ? void 0 : caterItem.Quantity) || 1);
          return acc;
        }, 0) + foodItems.reduce(function (acc, foodItem) {
          var _foodItem$Price4;

          acc += (foodItem === null || foodItem === void 0 ? void 0 : (_foodItem$Price4 = foodItem.Price) === null || _foodItem$Price4 === void 0 ? void 0 : _foodItem$Price4.Subtotal) * ((foodItem === null || foodItem === void 0 ? void 0 : foodItem.Quantity) || 1);
          return acc;
        }, 0)
      });
    }
  }, [destructuredCart === null || destructuredCart === void 0 ? void 0 : destructuredCart.foodItems]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Wrapper, {
    layout: layout,
    className: "cb-cart"
  }, /*#__PURE__*/React.createElement(Container, null, (limitModel === null || limitModel === void 0 ? void 0 : (_limitModel$RewardRed5 = limitModel.RewardRedemption) === null || _limitModel$RewardRed5 === void 0 ? void 0 : _limitModel$RewardRed5[0]) && /*#__PURE__*/React.createElement(RewardRedemptionModule, {
    model: limitModel.RewardRedemption[0].fields,
    authenticationState: authenticationState
  }), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    sm: "12",
    lg: "8",
    className: "cb-cart__content-wrapper"
  }, /*#__PURE__*/React.createElement(Alert, {
    show: fullCart === null || fullCart === void 0 ? void 0 : (_fullCart$displayErro = fullCart.displayErrors) === null || _fullCart$displayErro === void 0 ? void 0 : _fullCart$displayErro.length,
    variant: "danger"
  }, /*#__PURE__*/React.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: fullCart === null || fullCart === void 0 ? void 0 : (_fullCart$displayErro2 = fullCart.displayErrors) === null || _fullCart$displayErro2 === void 0 ? void 0 : _fullCart$displayErro2.join(', ')
    }
  })), /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(SectionBanner, {
    value: "Cart",
    index: 0,
    activeCategoryIndex: 0
  }, Boolean(amt) && /*#__PURE__*/React.createElement("span", {
    className: "cb-cart__num-items"
  }, amt, " ", itemHandler(amt))), /*#__PURE__*/React.createElement(Section, {
    className: "cb-cart__section-container"
  }, hasItemError && /*#__PURE__*/React.createElement("div", {
    className: "alert alert-danger",
    role: "alert"
  }, /*#__PURE__*/React.createElement("p", null, limitMessage)), /*#__PURE__*/React.createElement(CartLineGroup, _extends({}, props, {
    stashEdit: stashEdit,
    items: foodItems,
    title: "Food",
    removeItemRewardsConfirmationFields: removeItemRewardsConfirmationFields,
    authenticationState: authenticationState
  })), isFood && /*#__PURE__*/React.createElement("div", {
    className: "row d-flex justify-content-center"
  }, /*#__PURE__*/React.createElement(StateButton, {
    className: "cb-button-secondary",
    id: "addSilverware",
    onClick: function onClick() {
      window.location = silverwareRoute;
    }
  }, "Add Silverware N' Extras")), /*#__PURE__*/React.createElement(CartLineGroup, _extends({}, props, {
    stashEdit: stashEdit,
    items: caterItems,
    title: "Cater",
    removeItemRewardsConfirmationFields: removeItemRewardsConfirmationFields,
    authenticationState: authenticationState
  })), isCater && /*#__PURE__*/React.createElement("div", {
    className: "row d-flex justify-content-center"
  }, /*#__PURE__*/React.createElement(StateButton, {
    className: "cb-button-secondary",
    id: "addSilverware",
    onClick: function onClick() {
      window.location = '/catering/catering-supplies';
    }
  }, "Add Silverware N' Extras")), /*#__PURE__*/React.createElement(CartLineGroup, _extends({}, props, {
    stashEdit: stashEdit,
    items: retailItems,
    title: "Shop",
    removeItemRewardsConfirmationFields: removeItemRewardsConfirmationFields,
    authenticationState: authenticationState
  })))), /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement("h3", {
    className: "cb-cart__order-details-sections-title"
  }, "Order Details")), /*#__PURE__*/React.createElement(Container, {
    className: "cb-cart__order-details-sections"
  }, /*#__PURE__*/React.createElement(Section, null, isFood && /*#__PURE__*/React.createElement(CartOptionSelect, _extends({}, props, {
    deliveryOptions: deliveryModes["food"],
    isCater: false,
    leadTime: foodLead,
    title: "Food",
    index: sections.indexOf("2food")
  })), isCater && /*#__PURE__*/React.createElement(CartOptionSelect, _extends({}, props, {
    deliveryOptions: deliveryModes["cater"],
    isCater: isCater,
    leadTime: caterLead,
    title: "Catering",
    index: sections.indexOf("3cater"),
    setShippingMode: setShippingMode
  })))), isRetail && /*#__PURE__*/React.createElement(CartRetailSelect, _extends({}, props, {
    deliveryOptions: shippingModes,
    deliveryCosts: shippingCosts,
    title: "Retail",
    index: sections.indexOf("4retail"),
    setShippingMode: setShippingMode
  }))), /*#__PURE__*/React.createElement(Col, {
    sm: "12",
    lg: "4",
    className: "cb-cart__cost-wrapper cb-cart__section-container-cost"
  }, removeTipAndEntitlementsState && /*#__PURE__*/React.createElement(Cost, cost, /*#__PURE__*/React.createElement(MediaQuery, {
    maxWidth: 990
  }, authenticationState === AuthenticationState.Authenticated && /*#__PURE__*/React.createElement(StateButton, {
    className: "cb-button-primary",
    disabled: isDisabled || !!(fullCart === null || fullCart === void 0 ? void 0 : (_fullCart$displayErro3 = fullCart.displayErrors) === null || _fullCart$displayErro3 === void 0 ? void 0 : _fullCart$displayErro3.length),
    loading: isValidatingTimeWanted,
    id: "checkout",
    onClick: function onClick() {
      cartClick();
      validatePage();
    }
  }, "Checkout"), authenticationState !== AuthenticationState.Authenticated && /*#__PURE__*/React.createElement(StateButton, {
    className: "cb-button-primary",
    disabled: isDisabled || !!(fullCart === null || fullCart === void 0 ? void 0 : (_fullCart$displayErro4 = fullCart.displayErrors) === null || _fullCart$displayErro4 === void 0 ? void 0 : _fullCart$displayErro4.length),
    id: "signin",
    onClick: function onClick() {
      signInClick();
      signIn();
    }
  }, " Sign in"), authenticationState !== AuthenticationState.Authenticated && /*#__PURE__*/React.createElement(StateButton, {
    className: "cb-button-secondary",
    disabled: isDisabled || !!(fullCart === null || fullCart === void 0 ? void 0 : (_fullCart$displayErro5 = fullCart.displayErrors) === null || _fullCart$displayErro5 === void 0 ? void 0 : _fullCart$displayErro5.length),
    loading: isValidatingTimeWanted,
    id: "continue",
    onClick: function onClick() {
      continueGuestClick();
      validatePage();
    }
  }, "Continue as Guest"))), hasIPMerror && /*#__PURE__*/React.createElement("div", {
    className: "cb-l-margin-small--top"
  }, /*#__PURE__*/React.createElement("p", null, "*Total Individually Packaged Meals must be at least 8 and not exceed 20 items.")))))), /*#__PURE__*/React.createElement(MediaQuery, {
    minWidth: 991
  }, /*#__PURE__*/React.createElement(CartContinue, _extends({}, props, {
    disabled: !!(fullCart === null || fullCart === void 0 ? void 0 : (_fullCart$displayErro6 = fullCart.displayErrors) === null || _fullCart$displayErro6 === void 0 ? void 0 : _fullCart$displayErro6.length)
  }))));
}; // put back into buttons for router links
// href="/checkout"
// RouterStateButton


var exportCart = cartFormikEnhancer(Cart);
export { exportCart as Cart };